import toast from 'react-hot-toast';
import CasaAIModule from '../../CasaAI/interfaces/CasaAIModule';
import BusinessUnit from '../../../interfaces/BusinessUnit';
import axios from 'axios';
import config from '../../../config';
import CasaAISession from '../../CasaAI/interfaces/CasaAiSession';
import { CasaAIResponse } from '../../CasaAI/interfaces/MessageEntity';
import { ChanGroupedSessions } from "../interfaces/ChatSession";


export interface ChatResponse {
    taskId: string,
    status: string,
    sessionId: string,
    message: string,
    sessionName?: string,
}

const { apiServerUrl } = config;

const TASK_ENDPOINTS = {
    NORMAL: `${apiServerUrl}/users/chan/task`,
    INTERACTIVE: `${apiServerUrl}/users/chan/task`
};

export const sendChatMessage = async (tenant: BusinessUnit, message: string, sessionId: string, businessUnit: BusinessUnit, mode: string, draft: any = null): Promise<ChatResponse> => {

    try {
        const isInteractive = mode === 'interactive';
        const url = isInteractive ? TASK_ENDPOINTS.INTERACTIVE : TASK_ENDPOINTS.NORMAL;

        const payload: any = {
            tenant: tenant,
            business: businessUnit,
            userTask: message,
            sessionId: sessionId === "temp-session" ? "" : sessionId,
        };

        if (isInteractive) {
            payload.draft = draft;
        }

        return axios.post(url, payload)
            .then(({ data }) => {
                return {
                    taskId: data.task_id,
                    status: data.status,
                    sessionId: data.session_id,
                    message: data.message,
                    sessionName: data.sessionName,
                };
            });

        // const response = await getChatCompletionReply(
        //
        //   message,
        //   businessUnit,
        //  sessionId,
        //   CasaAIModule.CHAT_COMPLETION,
        // );
        // return {
        //   message: response.response.message,
        //   suggestedCustomizations: response.response.suggested_customizations || []
        // };
    } catch (error) {
        toast.error('Failed to get response. Please try again.');
        throw error;
    }
};

export const createNewChatSession = async (business: BusinessUnit) => {
    return axios
        .get(`${apiServerUrl}/users/casa-ai/${business.id}/session/chatCompletion/new`)
        .then((response) => {
            return response.data.data as CasaAISession;
        });
};


export const getChatCompletionReply = async (
    query: string,
    business: BusinessUnit,
    sessionId: string,
    module: CasaAIModule,
    isCustomized: boolean = false
): Promise<any> => {
    return axios
        .post<CasaAIResponse>(`${apiServerUrl}/users/casa-ai/message`, {
            message: query,
            businessUnit: business,
            sessionId,
            module,
            isCustomized
        })
        .then(({ data }) => data);
};





export const getChanMessageHistoryBySession = async (
    business: BusinessUnit,
    sessionId: string) => {
    // return axios
    //   .post<any>(`${apiServerUrl}/users/chan/history/session`, {
    //     businessUnit: business,
    //     sessionId,
    //   })
    //   .then(({ data }) => {
    //     return data;
    //   });
    return axios
        .get<any>(`${apiServerUrl}/users/chan/sessions/${sessionId}`)
        .then(({ data }) => {
            return data;
        });
}

// export const upsertUserMessage = async(tenantName: string, business: BusinessUnit, userMessage: string, sessionId: string) => {
//     return axios
//         .post<any>(`${apiServerUrl}/users/chan/`, {
//             tenant:tenantName, business:business, userTask:userMessage, sessionId:sessionId,
//     })
//     .then(({ data }) => {
//         return data;
//     });
// }

export const getChanTaskStatus = async (taskId: string) => {
    return axios
        .get(`${apiServerUrl}/users/chan/tasks/${taskId}/status`)
        .then((response) => {
            return response.data;
        });
}

export const cancelChanTask = async (taskId: string) => {
    return axios
        .post(`${apiServerUrl}/users/chan/task/cancel`, { task_id: taskId })
        .then((response) => {
            return response.data;
        });
}

export const resumeChatMessage = async (sessionId: string, userMessage: string, taskId: string, tenant: BusinessUnit, business: BusinessUnit, review: boolean) => {
    return axios
        .post(`${apiServerUrl}/users/chan/task/resume`,
            {
                sessionId: sessionId,
                userFeedback: userMessage,
                taskId: taskId,
                tenant: tenant,
                business: business,
                isJourneyTask: false,
                review: review,
            })
        .then(({ data }) => {
            return {
                taskId: data.task_id,
                status: data.status,
                sessionId: data.session_id,
                message: data.message
            };
        });
}

export const getChanSessions = async (businessUnitId: number) => {
    return axios
        .get(`${apiServerUrl}/users/chan/sessions/${businessUnitId}/list?sessionCount=50`)
        .then((response) => {
            return response.data.sessions;
        });

}

export const getChanGroupedSessions = async (businessUnitId: number, sessionCount: number, offset: number, searchTerm?: string) => {
    const searchParam = searchTerm?.trim() ? encodeURIComponent(searchTerm) : '';
    return axios
        .get(`${apiServerUrl}/users/chan/sessions/${businessUnitId}/list?sessionCount=${sessionCount}&offset=${offset}&searchTerm=${searchParam}`)
        .then((response) => {
            return response.data as ChanGroupedSessions;
        });
}

export const getNewSessionName = async(sessionId: string, userTask: string) => {
    return axios
        .patch(`${apiServerUrl}/users/chan/sessions/${sessionId}/name?userTask=${userTask}`)
        .then((res) => res.data);
}

export const updateChanSessionName = async (sessionId: string, sessionName: string) => {
    return axios
        .patch(`${apiServerUrl}/users/chan/sessions/${sessionId}/update?sessionName=${sessionName}`)
        .then((res) => res.data);
}

export const downloadChanTaskData = async (messageId: string) => {
    return axios.post(`${apiServerUrl}/users/chan/task/${messageId}/download`, {}, { responseType: 'blob' });
}

export const updateMessageFeedback = async (messageId: string, feedback: string | null) => {
    return axios
        .patch(`${apiServerUrl}/users/chan/messages/update`, {
            id: messageId,
            feedback: feedback
        })
        .then((res) => res.data);
}

export const cancelTask = async(taskId: string) => {
    return axios
        .post(`${apiServerUrl}/users/chan/task/cancel`, { taskId: taskId })
        .then((res)=> res.data)
}
